var $btnclick = $('.btn-click');

$btnclick.find('li').click(function () {  
  var tabid1 = $(this).children().attr('name');
  console.log(tabid1);
  var idb = $(tabid1).siblings('table');  
  var tli = $(this).siblings('li');
  var tbli = $(this);
  idb.hide();  
  $(tabid1).show();    
  tli.removeClass('active');
  tbli.focus().addClass("active");  
  
});

$('.slider-tab').slick({
  arrows: false,
  variableWidth: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  loop: false,
});

$('.tag-pagenews').each(function () {
  let $tag = $(this);

  $tag.find('.next').click(function () {
    $tag.find('.slider-tab').slick('slickNext');
  });
  $tag.find('.prev').click(function () {
    $tag.find('.slider-tab').slick('slickPrev');
  });

  $tag.find('.next').click(function () {
    $tag.find('.product-line').slick('slickNext');
  });
  $tag.find('.prev').click(function () {
    $tag.find('.product-line').slick('slickPrev');
  });
});

$('.product-line').slick({
  arrows: false,
  variableWidth: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 2,
});





// Scroll Monitor
window.scrollr = require("scrollMonitor")

// Floating Tabs
var $floatbar = $('#floatbar nav'),
  $parent = $floatbar.parent();
$parent.height($parent.height());

// Floatbar watcher
var fbWatcher = scrollr.create($floatbar);
fbWatcher.lock();
fbWatcher.stateChange(function () {
  $floatbar.toggleClass('fixed', this.isAboveViewport)
});
if (fbWatcher.isAboveViewport) {
  $floatbar.addClass('fixed');
}

window.scrollr = require("scrollMonitor")

// Floating Tabs

if($(window).width() < 768){
  var $floatbar = $('#floatbar .topnav'),
    $parent = $floatbar.parent();
  $parent.height($parent.height());

  // Floatbar watcher
  var fbWatcher = scrollr.create($floatbar);
  fbWatcher.lock();
  var lastScrollTop = 0;
  $(window).scroll(function(event){
    var st = $(this).scrollTop();
    if (st > lastScrollTop){
      fbWatcher.stateChange(function () {
        $floatbar.toggleClass('fixed', this.isAboveViewport)
      });
      if (fbWatcher.isAboveViewport) {
        $floatbar.addClass('fixed');
      }
    } else {
      fbWatcher.stateChange(function () {
        $floatbar.removeClass('fixed', this.isAboveViewport)
      });
      if (fbWatcher.isAboveViewport) {
        $floatbar.removeClass('fixed');
      }
    }
    lastScrollTop = st;
 });

 
}

// Tab watcher
$floatbar.find('ul li a').each(function () {
  var tabbtn = $(this),
    tabid = tabbtn.attr('href'),
    fheight = $floatbar.parent().height(),
    tabWatcher = scrollr.create(tabid, {
      top: fheight + 20,
      bottom: -fheight
    });

  // Highlight when scroll
  tabWatcher.stateChange(function () {
    var tabli = tabbtn.parent();
    if (!tabWatcher.isInViewport) {
      tabli.removeClass('active');
    } else if (tabWatcher.isInViewport && tabWatcher.isAboveViewport) {
      tabli.addClass('active');

      // Slide to active tab
      let index = tabli.data("index");
      $floatbar.find('.slider-tab').slick('slickGoTo', index);
    } else {
      tabli.removeClass('active');
    }
  });
});

// Click to scroll
$floatbar.find('ul li a').click(function () {
  var tabid = $(this).attr('href'),
    fheight = $floatbar.parent().height(),    
    top = $(tabid).offset().top - (fheight - 30);
  if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) window.scrollTo(0, top);
  else $("html,body").animate({ scrollTop: top }, 900);
  return false;
});


//auto sroll
if($(window).width() < 750 ){
  $('.srollDiv').css({"max-width":"400px"});
  $('.srollDiv').css({"overflow-x":"scroll"});
}


var $btnclick1 = $('.topnav-right');

$btnclick1.find('p').click(function () {  
  var tabid1 = $(this).attr('name');    

   $("#"+tabid1).show();    
  // tli.removeClass('active');
  // tbli.focus().addClass("active");  
  
});

function updownx(ab) {  
 
  var car_p = ab.siblings('.class-ctl');   
  var car_idown = ab.find('i.icon-down');   
  var car_iup = ab.find('i.icon-up');   
  // console.log(car_p);
  if(car_p.hasClass('active')){
    car_p.removeClass("active");  
  }else car_p.addClass("active");  
  
  if(car_p.hasClass('active')){
    console.log(car_iup);
    car_iup.css('display', 'block'); 
    car_idown.css('display', 'none'); 
  }else{
    
    car_iup.css('display', 'none'); 
    car_idown.css('display', 'block'); 
  }
  
  
 };




// WEBPACK FOOTER //
// ./src/article.js